export class DateFormatter {

  static format(value:number) {
    let date = new Date(value);
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    let month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);

    return day + '/' + month + '/' + date.getFullYear();
  }

  static getFirstDayOfCurrentMonth() {
    let date = new Date();
    let month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);

    return '01/' + month + '/' + date.getFullYear();
  }

  static getCurrentDate() {
    let date = new Date();
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
    let month = date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);

    return day + '/' + month + '/' + date.getFullYear();
  }

  static getCurrentMillis() : number {
    return new Date().getTime();
  }

  static getFifteenDaysAgo() : number {
    let now = new Date().getTime();
    let diff = 1000*60*60*24*15;

    return (now - diff);
  }

  static getFifteenDaysEarlier(date:number) : number {
    let diff = 1000*60*60*24*15;

    return (date - diff);
  }

  static getSevenDaysEarlier(date:number) : number {
    let diff = 1000*60*60*24*7;

    return (date - diff);
  }

  static getSevenDaysLater(date:number) : number {
    let diff = 1000*60*60*24*7;

    return (date + diff);
  }


  static getMillis(date: string) {
    let from = date.split("/");
    return new Date(Number(from[2]), Number(from[1]) - 1, Number(from[0])).getTime();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/date-formatter.ts